<template>
  <s-dialog to="stds-dialog-tutorial" size:sm :open="true">
    <s-dialog-overlay class="!bg-black/70" @click="$emit('close')" />
    <s-dialog-panel
      class="relative !w-[calc(100vw-4rem)] mx-auto sm:!w-[68.4rem] md:!w-[93.2rem] !rounded-none md:!rounded-[2.8rem]"
    >
      <st-dialog-header
        class="hidden md:flex text-on-surface-elevation-1 !font-bold"
        @clickClose="$emit('close')"
      >
        {{ $t('studio.lnb.common_2depth_tutorial_video') }}
      </st-dialog-header>
      <s-dialog-content class="p-0 m-0">
        <s-dialog-content-body class="!pb-0">
          <div class="relative w-full aspect-video flex items-center justify-center">
            <video
              ref="videoPlayer"
              controls
              :src="srcVideo"
              class="w-full h-full bg-contain bg-black/70"
              playsinline
              webkit-playsinline
              preload="metadata"
              controlsList="nodownload"
              x-webkit-airplay="deny"
              disablePictureInPicture
              autoplay
              @play="isPlaying = true"
              @pause="isPlaying = false"
              @ended="isPlaying = false"
            ></video>
          </div>
        </s-dialog-content-body>
        <s-dialog-footer class="hidden md:flex flex-col h-[12.6rem] gap-4 p-32 pb-40">
          <s-text as="h3" role="title6" class="text-on-surface-elevation-1 font-bold line-clamp-1">
            {{ title }}
          </s-text>
          <s-text as="p" role="text3" class="text-on-surface-elevation-3 line-clamp-1">
            {{ description }}
          </s-text>
        </s-dialog-footer>
      </s-dialog-content>
    </s-dialog-panel>
  </s-dialog>
  <s-portal-target name="stds-dialog-tutorial" />
</template>
<script setup lang="ts">
import { nextTick, onMounted, onUnmounted, ref } from 'vue';

import StDialogHeader from '@/components/common/st-dialog-header.vue';

defineProps<{
  thumbnailImage: string;
  imageAlt: string;
  title: string;
  description: string;
  srcVideo: string;
}>();

defineEmits<{
  close: [];
}>();
const videoPlayer = ref<HTMLVideoElement | null>(null);
const isPlaying = ref(false);

const disableScroll = () => {
  document.body.style.overflow = 'hidden';
};

const enableScroll = () => {
  document.body.style.overflow = '';
};

const handleFullscreenChange = () => {
  disableScroll();
};

onMounted(() => {
  nextTick(() => {
    if (!videoPlayer.value) {
      return;
    }
    // videoPlayer.value.style.backgroundImage = `url(${props.thumbnailImage})`;
    disableScroll();
    const playVideo = async () => {
      try {
        await videoPlayer.value?.play();
        isPlaying.value = true;
      } catch {}
    };

    playVideo();

    videoPlayer.value.addEventListener('fullscreenchange', handleFullscreenChange);
  });
});

onUnmounted(() => {
  if (videoPlayer.value) {
    videoPlayer.value.removeEventListener('fullscreenchange', handleFullscreenChange);
  }
  enableScroll();
});
</script>
